export const UPDATE_USER_DATA = 'update_user_data'
export const UPDATE_USER_ORGANIZATIONS = 'update_user_organizations'
export const UPDATE_ADMIN_USER_DATA = 'update_admin_user_data'
export const UPDATE_USER_ONBOARDING = 'update_user_onboarding'
export const LOGOUT_USER = 'logout_user'
export const LOGIN_USER = 'login_user'
export const ADD_ORGANIZATION_TYPES = 'add_organization_types'
export const INSERT_ORGANIZATION = 'insert_organization'
export const INSERT_ORGANIZATIONS = 'insert_organizations'
export const UPDATE_ORGANIZATION = 'update_organization'
export const DELETE_ORGANIZATION = 'delete_organization'
export const SET_CURRENT_ORGANIZATION = 'set_current_organization'
export const UPDATE_USER_ID = 'update_current_user_id'
export const SAVE_LICENSE_STATE = 'saveLicenseState'

export const ENABLE_SHOW_ONBOARDING = 'enable_show_onboarding'
export const ADD_USER_TOKEN = 'add_user_token'

export const RESET_USER = 'reset_user'

export const SET_GOALS = 'set_goals'

export const SET_WEEKLY_ACTIVE_STUDENTS = 'set_weekly_active_students'

export const SET_SESSION_EXPIRED = 'set_session_expired'

export const SET_FIRST_LOGIN = 'set_first_login'

export const ADD_ALL_CLASSES = 'add_all_classes'

export const SET_DETAIL_READALOUD = 'set_detail_readaloud'

export * from './organization'
export * from './admin'
export * from './classes'
export * from './invite'
export * from './students'
export * from './studysets'
export * from './assignments'
export * from './homeworks'
export * from './branches'
